export enum PaymentMethod {
  CASH = 'cash',
  TRANSFER = 'transfer',
  QRIS = 'qris',
  EDC = 'edc',
}

export enum SaleStatus {
  COMPLETED = 'COMPLETED',
  VOIDED = 'VOIDED',
}

export interface SaleItem {
  id: number;
  item_id: number;
  item_name: string;
  item_sku: string;
  qty: number;
  price: number;
  discount: number;
  subtotal: number;
}

export interface SaleItemCreate {
  item_id: number;
  qty: number;
  price: number;
  discount: number;  // Required with default 0
}

export interface PaymentDetail {
  id: number;
  method: PaymentMethod;
  amount: number;
  reference?: string;
  notes?: string;
  created_at: string;
}

export interface PaymentDetailCreate {
  method: PaymentMethod;
  amount: number;
  reference?: string;
  notes?: string;
}

export interface Sale {
  id: number;
  invoice_no: string;
  branch_id: number;
  user_id: number;
  subtotal: number;
  discount: number;
  discount_percentage?: number;
  discount_approved_by?: number;
  discount_approved_at?: string;
  tax: number;
  total: number;
  payment_method: PaymentMethod;
  amount_paid: number;
  change_amount: number;
  status: SaleStatus;
  notes?: string;
  customer_name?: string;
  customer_phone?: string;
  customer_id?: number;
  void_reason?: string;
  voided_at?: string;
  voided_by?: number;
  created_at: string;
  items: SaleItem[];
  payment_details?: PaymentDetail[];
}

export interface SaleListItem {
  id: number;
  invoice_no: string;
  branch_id: number;
  total: number;
  payment_method: PaymentMethod;
  status: SaleStatus;
  created_at: string;
  item_count: number;
}

export interface SaleCreate {
  items: SaleItemCreate[];
  payment_method: PaymentMethod;  // REQUIRED - primary payment method
  amount_paid: number;
  discount: number;  // Required with default 0
  discount_percentage?: number;
  discount_approved_by?: number;
  notes?: string;
  customer_name?: string;
  customer_phone?: string;
  customer_id?: number;
  payment_details?: PaymentDetailCreate[];  // Only used for split payments
}

export interface DiscountEligibilityRequest {
  customer_id?: number;
  items: SaleItemCreate[];
}

export interface DiscountEligibilityResponse {
  eligible: boolean;
  reason: string;
  available_discounts: number[];
  subtotal: number;
  total_quantity: number;
  customer_type?: string;
  member_status?: string;
}

export interface VoidSaleRequest {
  reason: string;
}

export interface VoidSaleResponse {
  message: string;
  sale: Sale;
}